"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverBubble = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_dom_1 = require("react-dom");
const react_popper_1 = require("react-popper");
const button_1 = require("@nbc-design/button");
const heading_1 = require("@nbc-design/heading");
const hooks_1 = require("@nbc-design/hooks");
const Close_1 = require("@nbc-design/icons/lib/web/Close");
const tokens_json_1 = tslib_1.__importDefault(require("@nbc-design/tokens/dist/styles/tokens.json"));
require("./popover.css");
/**
 * The PopoverBubble component is responsible for rendering the bubble content of a popover.
 * Unlike the Popover component, PopoverBubble is designed to be used independently, with the target element located outside of its scope.
 * To ensure correct positioning, create a ref on the target element and provide it via the anchorEl prop.
 */
const PopoverBubble = ({ open, anchorEl, onClose, title, content, position = 'auto', role = 'tooltip', className, closeAriaLabel, isPortal, preventOutsideClick = false, }) => {
    const [popperElement, setPopperElement] = React.useState(null);
    const popperRef = React.useRef(null);
    const [arrowElement, setArrowElement] = React.useState(null);
    const portalDivRef = React.useRef(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(anchorEl, popperElement, {
        modifiers: [
            {
                name: 'arrow',
                options: {
                    element: arrowElement,
                    padding: parseInt(tokens_json_1.default['s-xsmall'], 10),
                },
            },
            {
                name: 'offset',
                options: {
                    offset: [0, parseInt(tokens_json_1.default['s-normal'], 10)],
                },
            },
        ],
        placement: position,
    });
    const isPhone = (0, hooks_1.useMediaQuery)(`(max-width: ${tokens_json_1.default['bp-small']}px)`);
    React.useEffect(() => {
        if (!open)
            return;
        const handleEscape = (event) => {
            const activeElement = document?.activeElement;
            if (event.key === 'Escape') {
                onClose?.();
                setTimeout(() => {
                    activeElement?.blur();
                }, 10);
            }
        };
        window.addEventListener('keydown', handleEscape);
        return () => {
            window.removeEventListener('keydown', handleEscape);
        };
    }, [open, onClose]);
    React.useEffect(() => {
        popperRef.current = popperElement;
    }, [popperElement]);
    (0, hooks_1.useClickOutside)(popperRef, () => {
        if (!preventOutsideClick && open)
            onClose?.();
    });
    if (!open || !anchorEl)
        return null;
    const bubbleMarkup = ((0, jsx_runtime_1.jsxs)("div", { ref: setPopperElement, style: isPhone ? undefined : styles.popper, ...(isPhone ? {} : attributes.popper), className: (0, classnames_1.default)('dsc-popoverBubble', className), role: role === 'tooltip' ? 'tooltip' : undefined, children: [(0, jsx_runtime_1.jsxs)("span", { className: "dsc-popover__header", children: [(0, jsx_runtime_1.jsx)(heading_1.Heading, { type: "span", size: 5, children: title }), (0, jsx_runtime_1.jsx)(button_1.IconButton, { icon: (0, jsx_runtime_1.jsx)(Close_1.Close, { title: closeAriaLabel }), appearance: "minimal", onClick: onClose, className: "dsc-popover__closeIcon" })] }), (0, jsx_runtime_1.jsx)("span", { className: "dsc-popover__content", role: role === 'menu' ? 'menu' : undefined, children: content }), (0, jsx_runtime_1.jsx)("div", { ref: setArrowElement, className: "dsc-popover__arrow", style: styles.arrow })] }));
    const popoverMarkup = open && (isPhone || isPortal) ? ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(isPhone && open && 'dsc-popoverBubble__mobileContainer', isPortal && 'dsc-popoverBubble__portal'), ref: portalDivRef, children: bubbleMarkup })) : (open && bubbleMarkup);
    return isPortal ? (0, react_dom_1.createPortal)(popoverMarkup, document.body) : popoverMarkup;
};
exports.PopoverBubble = PopoverBubble;
//# sourceMappingURL=popoverBubble.js.map